import * as React from 'react';
import { useContext } from 'react';

import type { ProgramBySlugQuery_ProgramsV1Resource_slug_elements_curriculum as Curriculum } from 'bundles/unified-career-academy/queries/__generated__/ProgramBySlugQuery';

const ProgramCurriculumContext = React.createContext<Curriculum | undefined>(undefined);

export const useProgramCurriculum = () => {
  const programContext = useContext(ProgramCurriculumContext);

  return programContext;
};

export default ProgramCurriculumContext;
